import { Building2, Users, Tags, History } from "lucide-react";
import { StatsCard } from "@/components/ui/StatsCard";
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useQueryClient } from "@tanstack/react-query";

interface StatsSectionProps {
  dashboardStats: {
    companies: number;
    users: number;
    businessTypes: number;
  };
}

export const StatsSection = ({ dashboardStats }: StatsSectionProps) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    // Écouter les changements sur la table companies
    const companiesChannel = supabase
      .channel('companies-changes')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'companies' },
        () => {
          queryClient.invalidateQueries({ queryKey: ['admin-companies'] });
        }
      )
      .subscribe();

    // Écouter les changements sur la table profiles
    const profilesChannel = supabase
      .channel('profiles-changes')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'profiles' },
        () => {
          queryClient.invalidateQueries({ queryKey: ['admin-users'] });
        }
      )
      .subscribe();

    // Écouter les changements sur la table business_types
    const businessTypesChannel = supabase
      .channel('business-types-changes')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'business_types' },
        () => {
          queryClient.invalidateQueries({ queryKey: ['admin-business-types'] });
        }
      )
      .subscribe();

    // Écouter les changements sur la table poultry_transactions
    const activitiesChannel = supabase
      .channel('activities-changes')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'poultry_transactions' },
        () => {
          queryClient.invalidateQueries({ queryKey: ['admin-recent-activities'] });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(companiesChannel);
      supabase.removeChannel(profilesChannel);
      supabase.removeChannel(businessTypesChannel);
      supabase.removeChannel(activitiesChannel);
    };
  }, [queryClient]);

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <StatsCard
        title="Entreprises"
        value={dashboardStats.companies.toString()}
        description="Entreprises enregistrées"
        icon={Building2}
      />
      <StatsCard
        title="Utilisateurs"
        value={dashboardStats.users.toString()}
        description="Utilisateurs actifs"
        icon={Users}
      />
      <StatsCard
        title="Types d'entreprises"
        value={dashboardStats.businessTypes.toString()}
        description="Types disponibles"
        icon={Tags}
      />
      <StatsCard
        title="Activités récentes"
        value="0"
        description="Dernières 24 heures"
        icon={History}
      />
    </div>
  );
};